import { render, staticRenderFns } from "./EvaStatusChip.vue?vue&type=template&id=06bde8ae"
import script from "./EvaStatusChip.vue?vue&type=script&lang=ts"
export * from "./EvaStatusChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports